export const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";

export function getToken() {
  return localStorage.getItem("fpb_admin_token");
}

export function setToken(token) {
  localStorage.setItem("fpb_admin_token", token);
}

export function clearToken() {
  localStorage.removeItem("fpb_admin_token");
}

export function assetUrl(path) {
  if (!path) return "";
  const value = String(path).trim();
  if (!value) return "";
  if (/^(https?:|data:|blob:|mailto:|tel:)/i.test(value)) return value;

  const cleaned = value.replace(/\\/g, "/");

  if (cleaned.startsWith("/uploads/")) return `${API_BASE}${cleaned}`;
  if (cleaned.startsWith("uploads/")) return `${API_BASE}/${cleaned}`;

  const uploadIndex = cleaned.indexOf("/uploads/");
  if (uploadIndex >= 0) return `${API_BASE}${cleaned.slice(uploadIndex)}`;

  const uploadNoSlashIndex = cleaned.indexOf("uploads/");
  if (uploadNoSlashIndex >= 0) return `${API_BASE}/${cleaned.slice(uploadNoSlashIndex)}`;

  return value;
}

export async function api(path, options = {}) {
  const token = getToken();
  const headers = {
    ...(options.headers || {}),
  };

  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });

  const contentType = response.headers.get("content-type") || "";
  const data = contentType.includes("application/json") ? await response.json() : await response.text();

  if (!response.ok) {
    const message = typeof data === "string" ? data : data.error || "Request failed";
    throw new Error(message);
  }

  return data;
}

export async function uploadApi(path, formData, method = "POST") {
  return api(path, { method, body: formData });
}
